<div class="p-4">
    <h3 class="mb-2">Approve this cash out?</h3>
    <p class="sub-text">
        The voucher will be redeemed and cannot be reused. {{ data.voucherDetails.amount | number : '1.2-2' }} {{ data.voucherDetails.currency }} is credited to your
        wallet.
    </p>

    <div class="cash-row d-flex justify-content-between align-items-center my-4">
        <span class="row-label">Cash to hand over</span>
        <span class="row-value">{{ finalCashAmount | number : '1.2-2' }} {{ data.voucherDetails.currency }}</span>
    </div>

    <div class="d-flex gap-2">
        <button mat-stroked-button color="primary" class="rounded-pill flex-fill back-btn" (click)="back()">Back</button>
        <button mat-flat-button color="primary" class="rounded-pill flex-fill approve-btn" (click)="approve()">Approve</button>
    </div>
</div>
